





























































import { getSelectCourseList } from "@/api/globalSearch";
import { Vue, Component } from "vue-property-decorator";
@Component
export default class extends Vue {
  dialogVisible: boolean = false;
  searchName: string = "";
  selected: any[] = [];
  tableData: any[] = [];
  page: number = 1;
  pageSize: number = 10;
  pageSizeArray: number[] = [5, 10, 30, 50, 100];
  total: number = 0;
  created() {
    this.getList({
      page: 1,
      page_size: this.pageSize,
    });
  }
  handleSearch() {
    this.getList({
      page: 1,
      page_size: this.pageSize,
    });
  }
  showDialog() {
    this.dialogVisible = true;
  }
  hideDialog() {
    this.dialogVisible = false;
    const table: any = this.$refs.mainTable;
    table.clearSelection();
  }
  getList(params: { page: number; page_size: number }) {
    const option: any = {
      page: params.page,
      page_size: params.page_size,
      sales_status: 1,
    };
    if (this.searchName) {
      option.title = this.searchName;
    }
    getSelectCourseList(option).then((res: any) => {
      if (res.error_code === 0) {
        res.data.list.map((item: any) => {
          item.course_type = item.course_type === 1 ? "1vN" : "1v1";
        });
        this.tableData = res.data.list;
        this.total = res.data.total;
        this.page = params.page;
      }
    });
  }
  handleSelectionChange(arr: any[]) {
    this.selected = arr;
  }
  formSubmit() {
    this.$emit("on-change", this.selected);
    this.hideDialog();
  }
  handlePagerChange(e: number) {
    this.getList({
      page: e,
      page_size: this.pageSize,
    });
  }
  handlePagerSizeChange(e: number) {
    this.pageSize = e;
    this.getList({
      page: 1,
      page_size: e,
    });
  }
}
